import { Group, Shape } from 'ui/workflows/flowchart/types';
import { ShapeType } from '../../constants';
import { updateTooltip, doesShapeHaveVisibleTooltip } from '../tooltipUtils';
import { updateTextBackground } from './background';
import { optimizeMultilineText, OptimizeMultilineTextArgs } from './stringManipulation';
import { UpdateShapeTextArgs } from './types';
import { updateUnderline } from './underline';

/**
 * Fixes the size and position of linked shapes after the text change
 */
export const fixLinkedTextShapeSizes = (shape: Shape) => {
  if (!shape) return;

  if (doesShapeHaveVisibleTooltip(shape)) {
    updateTooltip({ shape });
  }

  if (shape.get(ShapeType.Underline)) {
    updateUnderline({ shape });
  }

  if (shape.get(ShapeType.Background)) {
    updateTextBackground({ shape });
  }
};

/**
 * Updates the actual text of a shape
 */
export const updateShapeText = ({
  className,
  text = '',
  group,
  shape,
}: Omit<UpdateShapeTextArgs, 'shape' | 'group'> & {
  className?: string;
  shape?: Shape;
  group?: Group;
}) => {
  const shapeRef = shape || (className && group?.findByClassName(className));
  if (shapeRef) {
    shapeRef.attr('text', text);
    fixLinkedTextShapeSizes(shape as Shape);
  }
};

/**
 * Truncates the text if it has gone over
 */
export const truncateTextIfNeeded = (shape: Shape, opts: OptimizeMultilineTextArgs) => {
  if (!shape) return;

  const attrs = shape.attr();
  const { text } = attrs;
  const truncatedText = optimizeMultilineText(text, { fontConfig: attrs, ...(opts || {}) });

  if (truncatedText !== text) {
    updateShapeText({ shape, text: truncatedText });
  }
};
